// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"50598a0f","453":"de3ea2da"}[chunkId] + ".chunk.js";
};